import React from 'react'
import PaginatorPageLink from './paginator-page-link'
import createReactClass from 'create-react-class'



var Paginator = createReactClass({
	getInitialState: function () {
		return {maxPageLinks: 10};
	},
	getPageLinksToShow: function () {
		var pageCount = this.getPageCount();
		if (pageCount < 11) {
			var start = 1;
			var end = pageCount;
		} else {
			var start = this.props.page - 5;
			if (start < 1) {
				start = 1;
			}
			var end = start + 9;
			if (end > pageCount) {
				end = pageCount;
			}
		}


		var pages = [];
		for (var i = start; i <= end; i++) {
			pages.push(i);
		}
		return pages;
	},
	getPageCount: function () {
		return Math.ceil(this.props.itemCount/this.props.perPage);
	},
	prevPage: function () {
		var prev = this.props.page - 1;
		if (prev < 1) {
			prev = 1;
		}
		this.props.pageClickCallback(prev);
	},
	nextPage: function () {
		var next = this.props.page + 1;
		if (next > this.getPageCount()) {
			next = this.getPageCount();
		}
		this.props.pageClickCallback(next);

	},
	render: function() {
		var pages = this.getPageLinksToShow();

		var pageComponents = [];
		for (var i = 0; i < pages.length; i++) {
			pageComponents.push(<PaginatorPageLink key={i} page={pages[i]} callback={this.props.pageClickCallback} selected={this.props.page == pages[i]} />)
		}

		if (pages.length <= 1) {
			return (<div></div>); //No pages to show, just show nothing
		} else if (this.getPageCount() <= 10) {
			//Don't show the prev and next buttons, just the page links
			return (
				<div className="ope-paginator">
					{pageComponents}
				</div>
			);
		} else {
			//Show page links and prev and next buttons
			return (
				<div className="ope-paginator">
					<div onClick={this.prevPage} className="ope-paginator__page">&lt;</div>
					<div onClick={this.nextPage} className="ope-paginator__page">&gt;</div>
					{pageComponents}
				</div>
			);
		}
	}
});

export default Paginator;
